<ng-container *ngIf="showBloque && !resizable">
  <nav class="nav-home-submenu" id="contenedor-home-nav-menu" [style]="{ '--color-texto': configBloque.color_texto, '--color-texto-tienda': configBloque.color_texto_tienda, '--color-inicial-nav': configBloque.color_inicial_nav, '--color-final-nav': configBloque.is_degradado ? configBloque.color_final_nav : configBloque.color_inicial }">
    <div class="nav-home-submenu-contenedor">
      <div class="blogs"><a [routerLink]="['blogs']">Blogs</a></div>
      <ng-container *ngIf="showRevista">
        <div class="revista">
          <a [routerLink]="['revistas', 'list_all']">{{ textoRevista }}</a>
        </div>
      </ng-container>
      <ng-container *ngIf="showTienda">
        <div class="shop">
          <a [href]="enlaceTienda" target="_blank">{{ textoTienda }}</a>
        </div>
      </ng-container>

      <div class="nav-home-noticias">
        <ng-container *ngIf="bannerTags">
          <ng-container *ngFor="let tag of tags; trackBy: trackByTag">
            <div [routerLink]="['tag', tag.nombreTag | kebabCase]" (onKeyPress)="setDocTitle('Tribuna - ' + tag.nombreTag)" class="noticias">{{ tag.nombreTag }}</div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </nav>
</ng-container>
